module.exports = __webpack_public_path__ + "static/media/groupNegative.48d29d9a.png";